import React from 'react';
import PropTypes from 'prop-types';
import { Image, FullwidthImage } from 'components';
import './ImageMosaic.scss';

const ImageMosaic = ({ images }) => (
  <div className={'image-mosaic'}>
    {images.length === 1 && (
      <FullwidthImage image={images[0].image.src} alt={images[0].image.alt} />
    )}
    {images.length === 2 && (
      <>
        <div className={'image-mosaic__double'}>
          <div className={'image-mosaic__single'}>
            <Image
              src={images[0].image.src}
              alt={images[0].image.alt}
              additionalClass={'image-mosaic__half'}
            />
          </div>
          <div className={'image-mosaic__single'}>
            <Image
              src={images[1].image.src}
              alt={images[1].image.alt}
              additionalClass={'image-mosaic__half'}
            />
          </div>
        </div>
      </>
    )}
    {images.length === 3 && (
      <>
        <FullwidthImage
          image={images[0].image.src}
          alt={images[0].image.alt}
        />
        <div className={'image-mosaic__double'}>
          <div className={'image-mosaic__single'}>
            <Image
              src={images[1].image.src}
              alt={images[1].image.alt}
              additionalClass={'image-mosaic__half'}
            />
          </div>
          <div className={'image-mosaic__single'}>
            <Image
              src={images[2].image.src}
              alt={images[2].image.alt}
              additionalClass={'image-mosaic__half'}
            />
          </div>
        </div>
      </>
    )}
    {images.length === 4 && (
      <>
        <FullwidthImage
          image={images[0].image.src}
          alt={images[0].image.alt}
        />
        <div className={'image-mosaic__double'}>
          <div className={'image-mosaic__single'}>
            <Image
              src={images[1].image.src}
              alt={images[1].image.alt}
              additionalClass={'image-mosaic__half'}
            />
          </div>
          <div className={'image-mosaic__single'}>
            <Image
              src={images[2].image.src}
              alt={images[2].image.alt}
              additionalClass={'image-mosaic__half'}
            />
          </div>
        </div>
        <FullwidthImage
          image={images[3].image.src}
          alt={images[3].image.alt}
        />
      </>
    )}
  </div>
);

ImageMosaic.propTypes = {
  images: PropTypes.array.isRequired,
};

export default ImageMosaic;
